"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _BaseComponents = require("../../StyledComponents/BaseComponents");
var _services = require("../../../services");
var _useRecommendationFullSpecs = require("../../../hooks/recommendation/useRecommendationFullSpecs");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const StyledGridRow = (0, _BaseComponents.GrayBackground)(_r10SourceLibrary.GridRow);
const FullSpecsBody = () => {
  const {
    groupedSpecs
  } = (0, _useRecommendationFullSpecs.useRecommendationFullSpecs)();
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "full-specs-body"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 6,
      bottom: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    layout: {
      sm: [8],
      md: [5],
      lg: [6]
    },
    justify: 'center'
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    appearance: "secondary",
    size: 2,
    justify: 'center',
    weight: 3,
    text: _services.locale.localeString('Recommendation.DeviceSpecs'),
    noMargin: true
  })))))), /*#__PURE__*/_react.default.createElement(StyledGridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, {
    noMargin: true
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 7,
      bottom: 7
    }
  }, groupedSpecs.map(specGroup => {
    const shouldShowSpecGroup = specGroup.specs.filter(spec => spec.valueText);
    return !!shouldShowSpecGroup.length && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      key: specGroup.name,
      spacingLevel: {
        top: 3,
        bottom: 3
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
      weight: 3,
      size: 1
    }, _services.locale.localeString(`SpecsGroup.${specGroup.name}`)), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.ListGroup, {
      listStyle: "default",
      type: "unordered"
    }, specGroup.specs.filter(spec => {
      return spec.valueText;
    }).map(spec => /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.ListItem, {
      key: spec.name
    }, _services.locale.localeString(`Specs.${spec.name}`), ":", ' ', _services.locale.localeString(`Specs.${spec.valueText}`, spec.valueText)))));
  })))));
};
var _default = FullSpecsBody;
exports.default = _default;